import { t } from 'ember-intl'
import SideNavItem from 'teacher-ui-client/components/side-nav/item'
import SideNavIconComponent from 'teacher-ui-client/components/side-nav/icon'
import type { TOC } from '@ember/component/template-only'

export const LongWritesLink: TOC<unknown> = <template>
  <SideNavItem data-test-side-nav-long-writes @linkTo="subscription-type.long-writes" @overrideDisabled={{true}}>
    <SideNavIconComponent @phosphorIcon="phosphor-scroll" @alt="Long Writes" />
    <span>{{t "sideNav.writing.longWrites"}}</span>
  </SideNavItem>
</template>

export default LongWritesLink
